import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';
import formService from '../../../services/formService';
import CourseObj from '../../../objects/courseType';

const FormItem = Form.Item;
const Option = Select.Option;

const defaultRules = [
  {
    required: true,
    message: '上课类型不能为空',
  },
];

const getActiveCourseTypes = (items) =>
  [...items]
    .filter((item) => item.isActive !== false)
    .sort((a, b) => Number(a.weight || 0) - Number(b.weight || 0));

const CourseTypeSingleFormItem = (props) => {
  const [courseTypes, setCourseTypes] = useState(CourseObj.courseType);
  let layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  let rules = props.rules ? props.rules : defaultRules;

  useEffect(() => {
    try {
      const cache = localStorage.getItem('COURSE_TYPE_LIST');
      if (cache) {
        setCourseTypes(getActiveCourseTypes(JSON.parse(cache)));
        return;
      }
    } catch (error) {
      localStorage.removeItem('COURSE_TYPE_LIST');
    }
    formService
      .queryCourseType()
      .then((res) => {
        const data = getActiveCourseTypes(res.data || []);
        localStorage.setItem('COURSE_TYPE_LIST', JSON.stringify(data));
        setCourseTypes(data);
      })
      .catch(() => setCourseTypes(getActiveCourseTypes(CourseObj.courseType)));
  }, []);

  return (
    <FormItem label='上课类型' {...layouts} name='courseType' rules={rules}>
      {
        <Select
          mode='single'
          showSearch
          optionFilterProp='children'
          filterOption={(input, option) =>
            String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          style={props.itemStyle}
          allowClear
          onChange={props.onChange}
        >
          {courseTypes.map((courseType) => (
            <Option key={courseType.type} value={courseType.type}>
              {courseType.name}
            </Option>
          ))}
        </Select>
      }
    </FormItem>
  );
};

export default CourseTypeSingleFormItem;
